import { onApiError } from "../error"
import { state } from '../state'
import { get } from "./client"

/**
 * @returns {Promise<Devices>}
 */
async function getDevices() {
    const user = await state.getActiveUser()
    const res = await get(`/users/${user.Id}/devices`)
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    getDevices
}
